
import { defineComponent, reactive } from 'vue'

import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { billing } from '@/core/realisations/billing.realisation'
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        'page-title': PageTitle,
        'the-input': TheInput,
        'the-button': TheButton,
    },
    setup() {
        const notifications = useNotifications()

        const state = reactive({
            start_date: null as string | null,
            end_date: null as string | null,
            is_loading: false,
        })

        const state_form$ = useVuelidate(
            {
                start_date: { required },
                end_date: { required },
            },
            state
        )

        const reset = () => {
            state.start_date = null
            state.end_date = null
            state_form$.value.$reset()
        }

        const saveFile = (content: File | Blob, file_name: string) => {
            const download_url = window.URL.createObjectURL(content)

            const link = document.createElement('a')
            link.href = download_url
            link.setAttribute('download', file_name)
            document.body.appendChild(link)
            link.click()
            link.remove()
        }

        const exportTranscripts = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const start_date = state.start_date as string
                const end_date = state.end_date as string

                const response = await billing.exportTranscripts(start_date, end_date)
                saveFile(response, `Транскрипты (${start_date} - ${end_date}).xlsx`)

                reset()
            } catch (error) {
                notifications.notifyError({
                    error,
                    title: 'При экспортировании транксриптов произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        return { state, state_form$, exportTranscripts }
    },
})
